//@flow
import { createStore, applyMiddleware } from 'redux';
import * as Immutable from 'immutable';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { persistStore, createTransform, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import { Reducers } from 'common/modules/redux';
import initialReducers from 'common/redux/reducers';
import { Record as ErrorRecord } from 'common/models/ErrorRecord';
import { FieldRecord } from 'common/models/field';

export default function configureStore() {
    const whitelistedReducer = ['appPreferences', 'uiSwitcher'];

    const counterTransform = createTransform(
        state => ({
            ...state,
            saveCounter: state.saveCounter ? state.saveCounter + 1 : 1
        }),
        state => ({
            ...state,
            rehydrateCounter: state.rehydrateCounter
                ? state.rehydrateCounter + 1
                : 1
        }),
        { whitelist: [...whitelistedReducer] }
    );

    const persistConfig = {
        key: 'appPreferences',
        storage,
        transforms: [counterTransform],
        whitelist: [...whitelistedReducer]
    };

    const reducers = new Reducers(initialReducers);
    const rootReducer = persistReducer(persistConfig, (state, action) => {
        return reducers.reduce(state, action);
    });
    const composedEnhancer = composeWithDevTools({
        serialize: {
            immutable: Immutable,
            refs: [ErrorRecord, FieldRecord]
        }
    })(applyMiddleware(thunk));
    const store = createStore(
        rootReducer,
        // Apply the state to restore the state when 'configureStore' gets called again
        // on HMR Update. This happens when we change i18n file.
        window.__stateToRestoreAfterHmrReload || {},
        composedEnhancer
    );
    const persistor = persistStore(store);

    // exposing reducers
    store.reducers = reducers;
    store.rootReducer = rootReducer;

    if (module.hot && process.env.NODE_ENV !== 'production') {
        module.hot.accept('common/redux/reducers', () => {
            try {
                store.replaceReducer(rootReducer);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(err);
            }
        });

        module.hot.dispose(() => {
            // Saving the state while disposing to re apply when HMR replaces this file.
            window.__stateToRestoreAfterHmrReload = store.getState();
        });
    }

    return { store, persistor };
}
